import { render, staticRenderFns } from "./Buffer.vue?vue&type=template&id=4ae9a425&scoped=true&"
import script from "./Buffer.vue?vue&type=script&lang=js&"
export * from "./Buffer.vue?vue&type=script&lang=js&"
import style0 from "./Buffer.vue?vue&type=style&index=0&id=4ae9a425&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae9a425",
  null
  
)

export default component.exports